import { render, staticRenderFns } from "./JdhModalDialog.vue?vue&type=template&id=3a57feb0&scoped=true&"
import script from "./JdhModalDialog.vue?vue&type=script&lang=ts&"
export * from "./JdhModalDialog.vue?vue&type=script&lang=ts&"
import style0 from "./JdhModalDialog.vue?vue&type=style&index=0&id=3a57feb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a57feb0",
  null
  
)

export default component.exports